export const validatePhoneNumber = new RegExp(/^$|^\+?[1-9]\d{10,14}$|^\d{10}$/g);

export const taxIdRegexValidation = new RegExp(/^(?:[0-9]{9})?$/);

export const ranRegexValidation = new RegExp(/^(?:[0-9A-Za-z]{1,34})?$/);

export const isValidDate = (dateString: string) => {
  const date = new Date(dateString);
  return date instanceof Date && !isNaN(date as any);
};
